import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/home/jamesb/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "d3-time-format.v2.min.js",
    "revision": "2e9ed5423aabfb58188c5f436860cdcc"
  },
  {
    "url": "d3-time.v1.min.js",
    "revision": "925d062c4ce2815f4cff17d13ff2d199"
  },
  {
    "url": "d3.v5.min.js",
    "revision": "f0b2ec5afc87eb622d86f587dad23e02"
  },
  {
    "url": "favicon.png",
    "revision": "8a55599ac978d707a5bda557dd82d28c"
  },
  {
    "url": "Gartoon_apps_date-192.png",
    "revision": "33e4c54765eba2e1963f34cb6c0ca6fc"
  },
  {
    "url": "Gartoon_apps_date-512.png",
    "revision": "e9c17001b91c2f367c976ab53491c10a"
  },
  {
    "url": "jqml.js",
    "revision": "8a26f84da8d5618607cc9ef96490d461"
  },
  {
    "url": "jquery-3.5.1.min.js",
    "revision": "dc5e7f18c8d36ac1d3d4753a87c98d0a"
  },
  {
    "url": "night.png",
    "revision": "101729e5425d6a5a5baed2d929a645e1"
  },
  {
    "url": "sunny.png",
    "revision": "9ae2ffdf3f6b13233e2eb75c4f29dcfc"
  },
  {
    "url": "timey3_icon_x192.png",
    "revision": "ed6bd64ecec568b5cd40fafffc05b9f9"
  },
  {
    "url": "timey3.css",
    "revision": "3094ee7c9f19373654c4aaeae6f83b7b"
  },
  {
    "url": "timey3.htm",
    "revision": "aa94ca4cf9cfcfb6f0df5de65ce60e4f"
  },
  {
    "url": "timey3.js",
    "revision": "541a6f45898776775937b4f2b4f48d6e"
  },
  {
    "url": "timey3.webmanifest",
    "revision": "52999c6448df367739202cb7e7b18e6e"
  }
], {
  "ignoreURLParametersMatching": []
});








